<div *ngIf="shouldShowPanel" id="nike-connected-overlay">
	<div id="chain">
        <homefield-icon width="66px" height="66px" name="chain-link"></homefield-icon>
    </div>
    <div id="connected" class="hmf-mt-s">Connected</div>
    <div class="hmf-grid logo-container hmf-mt-m">
		<homefield-icon
			width="90px"
			height="35px"
			name="{{brand.toLowerCase()}}-logo"
			class="hmf-p-xs hmf-span-3"
			fill="var(--hmf-gray50)">
		</homefield-icon>
		<homefield-icon
			width="80px"
			height="35px"
			name="branding-dsg-mono"
			class="hmf-p-xs hmf-span-3 dicks-logo"
			fill="var(--hmf-gray900)">
		</homefield-icon>
	</div>
</div>
